export var SelectedFilesSource;
(function (SelectedFilesSource) {
    SelectedFilesSource[SelectedFilesSource["LocalComputerFiles"] = 0] = "LocalComputerFiles";
    SelectedFilesSource[SelectedFilesSource["ProviderFiles"] = 1] = "ProviderFiles";
})(SelectedFilesSource || (SelectedFilesSource = {}));
//# sourceMappingURL=FilePickerResult.js.map